import {logger, repType} from './index';
import reportIds from './reportIds';

export const showCardLikeListLog = () => {
    logger(reportIds.showCardLikeList, repType.Show);
};

export const hoverCardLikeListUserItemLog = () => {
    logger(reportIds.hoverCardLikeListUserItem, repType.Show);
};

export const showCardLikeNewGuidLog = () => {
    logger(reportIds.showCardLikeNewGuid, repType.Show);
};

export const cardLikeChangeLog = (params: {clickType: number, number: number}) => {
    logger(reportIds.cardLikeChange, repType.Click, params);
};

export const hoverCardLikeIconLog = () => {
    logger(reportIds.hoverCardLikeIcon, repType.Show);
};

export const userHoverCardLog = () => {
    logger(reportIds.userHoverCard, repType.Show);
};
